
export default function Simulation3() {
  const handleBackToMenu = () => {
    window.location.href = 'https://naruhodo-wakaru.com/jss/shitoriSim4taku.html?v=1';
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-8" style={{ backgroundColor: '#f9f9f9' }}>
      <div className="w-full max-w-4xl">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">シミュレーション③</h1>
        
        <div className="w-full max-w-[800px] mx-auto mb-8">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://player.vimeo.com/video/1135008537?autoplay=1&muted=1"
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="シミュレーション③"
            />
          </div>
        </div>
        
        <div className="text-center">
          <a
            href="https://naruhodo-wakaru.com/jss/shitoriSim4taku.html?v=1"
            target="_self"
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-8 py-3 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer inline-block"
          >
            選択画面に戻る
          </a>
        </div>
      </div>
    </div>
  );
}
